import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom'
import {
  Box,
  Text,
  useDisclosure,
  Alert,
  AlertIcon,
  Table,
  Tbody,
  Td,
  Tr,
  Button, Flex,
  Badge,
  useToast,
  HStack,
} from '@chakra-ui/react';
import axios from "axios";
import EnrolmentForm from '../Components/EnrolmentForm';
import { EnrolmentData, EnrolmentMetaData, CombinedEnrolment, StudentMetaData, Student } from "../Common/types";
import { jwtDecode } from "jwt-decode";
import { toUtcISOString, parseUtc, fmtLocal } from "../../utils/dates";

// Define the expected structure of the token payload
interface TokenPayload {
    sub: string;       // Typically the username or user ID
    role_id: number;   // Role ID
    tenant_id: number; // Tenant ID
    exp?: number;      // Expiration timestamp (optional)
  }
  

interface User{
    user_id : number;
    username : string;
    email : string;
    password : string;
    tenant_id : number;
    role_id:number;
    is_active : boolean;
}


  const ReviewStudent = () => {


    const [message, setMessage] = useState<string>("");
    const [user, setUser] = useState<string | null>(null);

    const [enrolmentDetails, setEnrolmentDetails] = useState<EnrolmentData | null>(null); // Adjust type to match FormData
   
    const [studentMetaData, setStudentMetaData] = useState<StudentMetaData | null>(null);


    const { student_id } = useParams<{ student_id: string }>();
    console.log("student id is ",student_id);


    const toast = useToast();


    const fetchStudentDetails = async () => {
        try {
            const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";
            const response = await axios.get(`${apiurl}/student/${student_id}`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            });
         // setEnrolmentDetails(response.data); // Assuming the API returns the enrolment data in the correct format
          setEnrolmentDetails({
              mother: response.data.mother,
              father: response.data.father,
              emergencyContact: response.data.emergencyContact,
              student: response.data.student,
              preferredCourses: response.data.preferredCourses,
              heardAboutUs: response.data.heardAboutUs,
              medicalAndOtherInfo: response.data.medicalAndOtherInfo,
              tenant_id: response.data.tenant_id,
              enrolmentMode : response.data.enrolmentMode,
          });
    
          setStudentMetaData({
              student_id:response.data.student_id,
              is_active:response.data.is_active,
              user_id: response.data.user_id,
              actioned_by: response.data.actioned_by,
              created_at: new Date(response.data.created_at),
              updated_at: new Date(response.data.updated_at),
              enrolmentMode : response.data.enrolmentMode,
          });
    
    
    
        } catch (error) {
          console.error('Error fetching enrolment details:', error);
        }
      };
    

// Function to get tenant_id from the token
const getUserFromToken = (token: string): string | null => {
    try {
        const decoded: TokenPayload = jwtDecode<TokenPayload>(token);
        return decoded.sub ;
    } catch (error) {
        console.error("Error decoding token:", error);
        return null;
    }
    };


  useEffect(() => {

    const token = localStorage.getItem("token");
    if (token) {
        const username = getUserFromToken(token);
        console.log("User:", username);
        setUser(username);
    }

    if (student_id) {
      fetchStudentDetails();
      console.log("Enrolment details fetched got the student details")
    }
  }, [student_id]);

  if (!enrolmentDetails) {
    return <p>Loading enrolment details...</p>; // Add a loading spinner if needed
  }

  if (!studentMetaData) {
    return <p>Loading enrolment details...</p>; // Add a loading spinner if needed
  }
  else
  {
    if(!studentMetaData.is_active)
    {
      
    }
  }

  const updateStudent = async (enrolmentData: EnrolmentData) => {
    setEnrolmentDetails(enrolmentData);
    try {
        // Validate enrolment metadata
        if (!studentMetaData) {
            toast({
                title: "Missing Metadata",
                description: "Enrolment metadata is missing. Cannot update.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        // Normalize `user` to `undefined` if it is `null`
        const normalizedUser = user ?? "admin";

        // Construct updated metadata
        const updatedMetaData = {
            student_id: studentMetaData.student_id,
            is_active : studentMetaData.is_active,
            actioned_by: normalizedUser,
            created_at: studentMetaData.created_at,
            updated_at: studentMetaData.updated_at,
            user_id: studentMetaData.user_id, // Defaulted to `undefined` as per current logic
        };

        console.log("Agreed To Field Value", enrolmentData.medicalAndOtherInfo.agreeToCosts);

        // Combine enrolment data with review metadata
        const payload: Student = {
            ...updatedMetaData,
            ...enrolmentData,
        };

        // Send the API request
        const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";
        const response = await axios.put(`${apiurl}/update-student/${student_id}`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });

        // Handle success response
        if (response.data.isRegistrationSuccess) {
            toast({
                title: "Student Updated",
                description: `Student with ID ${student_id} has been successfully updated.`,
                status: "success",
                duration: 3000,
                isClosable: true,
            });
            fetchStudentDetails();
        } else {
            toast({
                title: "Update Incomplete",
                description: "The student could not be updated ",
                status: "warning",
                duration: 3000,
                isClosable: true,
            });
        }
    } catch (error) {
        // Handle Axios errors
        if (axios.isAxiosError(error)) {
            toast({
                title: "Error Updating Student",
                description: error.response?.data?.detail || "Failed to update student due to a server error.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        } else {
            // Handle other types of errors
            toast({
                title: "Unexpected Error",
                description: error instanceof Error ? error.message : "An unexpected error occurred.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
        console.error("Error updating student:", error);
    }
};

  return (
    <Box as="main" mx="auto" p={10} >
        <Box p={4} borderColor={"gray.300"} borderWidth={1} borderRadius="sm" mb={4}>
            {studentMetaData && enrolmentDetails? (
                <Table variant="simple" size="sm" mb={2}>
                    <Tbody>
                        <Tr>
                            <Td fontSize="lg" fontWeight="bold">Student Details</Td>               
                        </Tr>
                        <Tr>
                            <Td fontWeight="bold">Student ID</Td>
                            <Td>{studentMetaData.student_id}</Td>
                        </Tr>
                        <Tr>
                            <Td fontWeight="bold">Student Name</Td>
                            <Td>{enrolmentDetails.student.givenName + ' '+ enrolmentDetails.student.surname }</Td>
                        </Tr>
                        <Tr>
                            <Td fontWeight="bold">Actioned By</Td>
                            <Td>{studentMetaData.actioned_by || "N/A"}</Td>
                        </Tr>
                        <Tr>
                            <Td fontWeight="bold">Created At</Td>
                           
                             <Td>{fmtLocal(studentMetaData.created_at)}</Td>
                        </Tr>
                        <Tr>
                            <Td fontWeight="bold">Updated At</Td>
                            <Td>{fmtLocal(studentMetaData.updated_at)}</Td>              
                        </Tr>
                        <Tr>
                            <Td fontWeight="bold">Status</Td>
                            <Td>{studentMetaData.is_active ? ("Active") : ("Inactive")}</Td>
                            
                        </Tr>
                        
                    </Tbody>
                </Table>
            ) : (
                <Text>Loading metadata...</Text>
            )}
        </Box>

        <Box pb={4}>
      <Box>
        <Text fontWeight="bold" mb={2}>
          Student Form:
        </Text>
        <Box>
          {!studentMetaData.is_active ? (
            <Alert status="warning" mt={4}>
              <AlertIcon />
              Student details cannot be edited as the student is inactive.
            </Alert>
          ) : (
            <EnrolmentForm
              mode="review"
              studentEnrolmentData={enrolmentDetails}
              onSave={updateStudent}
              formReset={false}
              enrolmentMode={enrolmentDetails.enrolmentMode}
            />
          )}
          {message && (
            <Alert status="info" mt={4}>
              <AlertIcon />
              {message}
            </Alert>
          )}
        </Box>
      </Box>
    </Box>
      </Box>        
  );
};

export default ReviewStudent;

